import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";
import { formateDate } from "../../utils/dateUtil";

class HistoryLogsDepartmentModal extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
  };

  static propTypes = {
    logs: PropTypes.array.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    // console.log();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "作業內容",
        dataIndex: "RecordDescription",
        width: 40,
      },
      {
        title: "作業時間",
        dataIndex: "RecordCreateDatetime",
        width: 20,
        render: (RecordCreateDatetime) => formateDate(RecordCreateDatetime),
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading } = this.state;
    const { logs } = this.props;
    console.log(logs);
    return (
      <Card>
        <Table
          dataSource={logs}
          columns={this.columns}
          loading={loading}
          rowKey="Uid"
          scroll={{ y: 460 }}
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(HistoryLogsDepartmentModal);
